import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import {
  activeCasesApi,
  adminEventsApi,
  adminUsersApi,
  aircraftStatusesApi,
  alertsApi,
  caseTimelineApi,
  caseTrackingApi,
  domainEventsApi,
  geoLibraryApi,
  hubsResourceReportApi,
  mapTimelineApi,
  newCasesApi,
  nopResourcesApi,
  settingsApi,
  simpleStatisticsApi,
  statsApi,
  surgeonsApi,
  weatherSnapshotApi,
} from '#entities';
import {
  alertFilterSlice,
  eventFilterSlice,
  fleetFilterSlice,
  liveSyncSlice,
  mapFocusSlice,
  uiSessionSlice,
} from '#shared';

import { notificationSlice } from '#domains/shell';

import { uiSessionPersistConfig } from './persistConfig';

// Build base reducer
export const rootReducer = combineReducers({
  uiSession: persistReducer(uiSessionPersistConfig, uiSessionSlice.reducer),
  notification: notificationSlice.reducer,
  liveSync: liveSyncSlice.reducer,
  mapFocus: mapFocusSlice.reducer,
  eventFilter: eventFilterSlice.reducer,
  fleetFilter: fleetFilterSlice.reducer,
  alertFilter: alertFilterSlice.reducer,
  [domainEventsApi.reducerPath]: domainEventsApi.reducer,
  [alertsApi.reducerPath]: alertsApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [newCasesApi.reducerPath]: newCasesApi.reducer,
  [hubsResourceReportApi.reducerPath]: hubsResourceReportApi.reducer,
  [nopResourcesApi.reducerPath]: nopResourcesApi.reducer,
  [geoLibraryApi.reducerPath]: geoLibraryApi.reducer,
  [adminUsersApi.reducerPath]: adminUsersApi.reducer,
  [adminEventsApi.reducerPath]: adminEventsApi.reducer,
  [activeCasesApi.reducerPath]: activeCasesApi.reducer,
  [caseTimelineApi.reducerPath]: caseTimelineApi.reducer,
  [caseTrackingApi.reducerPath]: caseTrackingApi.reducer,
  [aircraftStatusesApi.reducerPath]: aircraftStatusesApi.reducer,
  [surgeonsApi.reducerPath]: surgeonsApi.reducer,
  [simpleStatisticsApi.reducerPath]: simpleStatisticsApi.reducer,
  [statsApi.reducerPath]: statsApi.reducer,
  [weatherSnapshotApi.reducerPath]: weatherSnapshotApi.reducer,
  [mapTimelineApi.reducerPath]: mapTimelineApi.reducer,
});

// Export RootState type - this can now be imported by slices without circular dependency
export type RootState = ReturnType<typeof rootReducer>;
